import React from "react";
import ClickableImage from "./ClickableImage";
import { translate } from "../types/EnumTranslations";
import COLORS, { displayHazards } from "../Helpers/utils";
import "./ComponentCard.css";
import {BaseComponentImpl} from "../types/implementations";

export interface ComponentCardProps {
    component: BaseComponentImpl;
    buildingKey: string;
    onNavigate: (componentKey: string) => void;
}

const ComponentCard: React.FC<ComponentCardProps> = ({ component, buildingKey, onNavigate }) => {

    const maxPhotos = 3
    const photoSize = 112

    return (
        <div
            className="component-card"
            style={{ fontSize: '9pt', padding: '20px', paddingTop: '26px' }}
            onClick={() => onNavigate(component.key)}
        >
            <div className="component-card-timestamp">
                Uppdaterad: 2025-01-25
            </div>
            <h4>{component.displayName()}</h4>

            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <span className="component-card-label">{translate(component.specificType)}</span>
                {
                    component.material?.value &&
                    (component.material?.value.map((material) => (
                        <span className="component-card-label">{translate(material)}</span>
                    )))
                }

                {
                    component.areaShapes?.value && component.totalArea() &&
                    <span className="component-card-label">{component.totalArea()} kvm</span>
                }
            </div>

            {
                component.hazardous?.value &&
                <span className="component-card-label" style={{ color: "white", backgroundColor: COLORS.deepRed, marginTop: '8px' }}>
                    {displayHazards((component.hazardous.value))}
                </span>
            }

            {
                component.photos &&
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: '20px' }}>
                    {component.photos && buildingKey && Object.entries(component.photos).slice(0, maxPhotos).map(([key, photo]) => (
                        <ClickableImage
                            key={key}
                            buildingKey={buildingKey}
                            photo={photo}
                            disableClick={true}
                            size={photoSize}
                        />
                    ))}
                    {component.photos && Object.keys(component.photos).length > maxPhotos && (
                        <div
                            style={{
                                width: `${photoSize}px`,
                                height: `${photoSize}px`,
                                backgroundColor: '#cccccc',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14pt',
                                borderRadius: '4px'
                            }}
                        >
                            +{Object.keys(component.photos).length - maxPhotos}
                        </div>
                    )}
                </div>
            }
        </div>
    );
};

export default ComponentCard;